"use client";
import { Suspense } from "react";
import dynamic from "next/dynamic";

import { useStore, observer } from "../../../../service/mobx";

const NoInput = dynamic(() => import("./NoInput"));
const FourUp = dynamic(() => import("./FourUp"));

function NoEntitySelected({ trending, topModels }) {
  const { search } = useStore();

  return (
    <Suspense>
      {search.hasQuery ? (
        <FourUp />
      ) : (
        <NoInput trending={trending} topModels={topModels} />
      )}
    </Suspense>
  );
}

export default observer(NoEntitySelected);
